<script lang="ts" setup>
import { ref, inject, onMounted, provide, watch, computed } from 'vue';
import CollapseFieldset from '@/components/CollapseFieldset.vue';
import EnvmapFileSelect from '@/components/Lighting/EnvmapFileSelect.vue';
import EnvmapRotation from '@/components/Lighting/EnvmapRotation.vue';
import EnvmapIntensity from '@/components/Lighting/EnvmapIntensity.vue';
import EnvmapPath from '@/components/Lighting/EnvmapPath.vue';

import type { Ref } from 'vue';
import type { Viewer } from '@immersive-tech/viewer-engine';
import type { IManifest } from '@/types/IManifest';

const viewer = inject('viewer') as Ref<Viewer>;
const manifest = inject('manifest') as Ref<IManifest>;
const envMapFile = ref('environment.env');
const envMapPath = ref('/');

const envmap = computed(() => {
  if (envMapPath.value.endsWith('/')) {
    return envMapPath.value + envMapFile.value;
  }

  return envMapPath.value + '/' + envMapFile.value;
});

provide('envMapPath', envMapPath);
provide('envMapFile', envMapFile);
provide('envmap', envmap);

const mountedHandler = () => {
  if (!manifest.value.envmap) return;

  const envMapInfo = manifest.value.envmap.split('/');

  envMapFile.value = envMapInfo[envMapInfo.length - 1];
  envMapPath.value = envMapInfo.slice(0, envMapInfo.length - 1).join('/');
};

const manifestEnvMapWatcher = (newValue: string, oldValue: string) => {
  if (newValue === oldValue) return;

  const envMapInfo = manifest.value.envmap.split('/');

  envMapFile.value = envMapInfo[envMapInfo.length - 1];
  envMapPath.value = envMapInfo.slice(0, envMapInfo.length - 1).join('/');
};

const envmapWatcher = (newValue: string, oldValue: string) => {
  if (newValue === oldValue) return;

  manifest.value.envmap = newValue;

  viewer.value.environmentMap = `/content/dam/LifeTech/virtual/common/envmap/${envMapFile.value}`;
};

onMounted(mountedHandler);
watch(() => manifest.value.envmap, manifestEnvMapWatcher);
watch(envmap, envmapWatcher);
</script>

<template>
  <CollapseFieldset :enable-collapse="false">
    <template #legend>
      Environment Map
    </template>

    <EnvmapFileSelect />
    <EnvmapPath />
    <EnvmapIntensity />
    <EnvmapRotation />
  </CollapseFieldset>
</template>
